import { createIcon } from "@chakra-ui/icons";

// Created from image.svg

export const ImageIcon = createIcon({
  displayName: "Image",
  viewBox: "0 0 20 20",
  path: (
    <g>
      <path
        d="M17 1H3C1.89543 1 1 1.89543 1 3V17C1 18.1046 1.89543 19 3 19H17C18.1046 19 19 18.1046 19 17V3C19 1.89543 18.1046 1 17 1Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 13L3.70204 9.91196C4.11584 9.43903 4.85816 9.46049 5.24396 9.95652L7.10401 12.348C7.53543 12.9027 8.38932 12.8511 8.75086 12.2486L11.5628 7.56207C11.9687 6.88543 12.9618 6.92357 13.3147 7.62935L14.9466 10.8931C15.3412 11.6824 16.4903 11.6109 16.784 10.7787L19 4.5"
        fill="none"
        stroke="currentColor"
      />
      <circle cx="5.5" cy="4.5" r="1.1" fill="none" stroke="currentColor" strokeWidth="0.8" />
    </g>
  ),
});
